import { render, staticRenderFns } from "./DiseasaOrgan.vue?vue&type=template&id=455679c3&scoped=true&"
import script from "./DiseasaOrgan.vue?vue&type=script&lang=js&"
export * from "./DiseasaOrgan.vue?vue&type=script&lang=js&"
import style0 from "./DiseasaOrgan.vue?vue&type=style&index=0&id=455679c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455679c3",
  null
  
)

export default component.exports